export default __webpack_public_path__ + "static/media/VARB.5d09f42c.jpg";